import { SHA256 } from "crypto-js";
export function calculateHash(data, nonce, timestamp, previousHash = "") {
  const payload = JSON.stringify(data);
  const pattern = previousHash + timestamp + nonce + payload;
  return SHA256(pattern).toString();
}
